import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/phone.svg'
import _imports_1 from '@/assets/img/edit.svg'
import _imports_2 from '@/assets/img/mail.svg'
import _imports_3 from '@/assets/img/driver_icon.svg'


const _hoisted_1 = { class: "tecnicoDetail" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "fs_12 fw_500" }
const _hoisted_5 = { class: "d-flex align-items-center mb-2 mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "ms-2 me-1"
}
const _hoisted_8 = {
  key: 1,
  class: "ms-2 me-1"
}
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_11 = { class: "ms-2 me-1" }
const _hoisted_12 = { class: "driverInfoContainer" }
const _hoisted_13 = {
  key: 0,
  class: "driverLabel"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "me-1"
}, null, -1)
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "me-5" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "me-5" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_technicians_images = _resolveComponent("technicians-images")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_technicians_images, {
        role: _ctx.technicianDetail.role,
        class: "icona"
      }, null, 8, ["role"]),
      (_ctx.technicianDetail.role)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: _ctx.technicianDetail.role.toLowerCase(),
            text: _ctx.technicianDetail.role.toLowerCase(),
            class: "text-capitalize fs_12 fw_500 marine ms-1"
          }, null, 8, ["localizedKey", "text"]))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            localizedKey: "Polivalente",
            text: "Polivalente",
            class: "text-capitalize fs_12 fw_500 marine ms-1"
          }))
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.technicianDetail.name) + " " + _toDisplayString(_ctx.technicianDetail.surname), 1),
    _createElementVNode("span", _hoisted_4, "ID:" + _toDisplayString(_ctx.technicianDetail.uId), 1),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_ctx.technicianDetail.phone)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.technicianDetail.phone), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, "-------------")),
      _createElementVNode("img", {
        src: _imports_1,
        class: "pointer me-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editPhoneNumber()))
      }),
      (_ctx.technicianDetail.phone)
        ? (_openBlock(), _createBlock(_component_copy_button, {
            key: 2,
            text: _ctx.technicianDetail.phone
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.technicianDetail.email), 1),
      _createVNode(_component_copy_button, {
        text: _ctx.technicianDetail.email
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.technicianDetail.vehicleDetails.veicolo || _ctx.technicianDetail.vehicleDetails.stato)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_localized_text, {
              localizedKey: "Driver",
              text: "Driver"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_localized_text, {
            localizedKey: "Veicolo:",
            text: "Veicolo:",
            class: "fs_12 fw_500 d-block mb-1"
          }),
          (_ctx.technicianDetail.vehicleDetails.veicolo)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.technicianDetail.vehicleDetails.veicolo), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_18, "---"))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_localized_text, {
            localizedKey: "Stato:",
            text: "Stato:",
            class: "fs_12 fw_500 d-block mb-1"
          }),
          (_ctx.technicianDetail.vehicleDetails.stato)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.technicianDetail.vehicleDetails.stato), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_21, "---"))
        ])
      ])
    ])
  ]))
}